import { render, staticRenderFns } from "./ConfiguracoesPorPv.vue?vue&type=template&id=54969228&scoped=true&"
import script from "./ConfiguracoesPorPv.vue?vue&type=script&lang=js&"
export * from "./ConfiguracoesPorPv.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracoesPorPv.vue?vue&type=style&index=0&id=54969228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54969228",
  null
  
)

export default component.exports